'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { combineReducers } from 'redux';
import { isEqual } from 'underscore';
import { ERROR, WARNING, SUCCESS, INFO } from 'DesignData/enums/EditorErrorTypes';
import { EDITOR_ERRORS_CLEAR, EDITOR_ERRORS_CLEAR_ALL, EDITOR_ERRORS_SET, EDITOR_ERRORS_ADD, EDITOR_ERRORS_HUBL_SET, EDITOR_ERRORS_HUBL_CLEAR, EDITOR_ERRORS_HUBL_CLEAR_ALL, EDITOR_ERRORS_CSS_SET, EDITOR_ERRORS_CSS_CLEAR, EDITOR_ERRORS_CSS_CLEAR_ALL, EDITOR_ERRORS_JS_SET, EDITOR_ERRORS_JS_CLEAR, EDITOR_ERRORS_JS_CLEAR_ALL } from 'DesignData/actions/ActionTypes';
import { EMPTY_OBJECT } from 'DesignData/lib/object';
import { EMPTY_ARRAY } from 'DesignData/lib/array';

function setErrors(state, assetId, errors) {
  const currentErrors = state[assetId];

  if (currentErrors === errors || currentErrors && errors && currentErrors.length === errors.length && currentErrors.every((err, idx) => isEqual(err, errors[idx]))) {
    return state;
  }

  const newList = errors && errors.length ? errors : EMPTY_ARRAY;
  return SeamlessImmutable.set(state, assetId, newList);
}

function addErrors(state, assetId, errors) {
  const errorQueue = state[assetId];

  if (!errorQueue) {
    return setErrors(state, assetId, errors);
  }

  return setErrors(state, assetId, errorQueue.concat(errors));
}

function createErrorReducer(errorType) {
  return (state = EMPTY_OBJECT, action) => {
    switch (action.type) {
      case EDITOR_ERRORS_ADD:
      case EDITOR_ERRORS_SET:
        {
          const {
            assetId,
            groupedErrors
          } = action;
          if (!(assetId, groupedErrors)) return state;
          const errors = groupedErrors[errorType];
          if (!(errors && errors.length)) return setErrors(state, assetId, EMPTY_ARRAY);
          return action.type === EDITOR_ERRORS_ADD ? addErrors(state, assetId, errors) : setErrors(state, assetId, errors);
        }

      case EDITOR_ERRORS_CLEAR:
        {
          const {
            assetId
          } = action;
          if (!state[assetId]) return state;
          return SeamlessImmutable.without(state, assetId);
        }

      case EDITOR_ERRORS_CLEAR_ALL:
        {
          return EMPTY_OBJECT;
        }

      default:
        return state;
    }
  };
}

const errorsById = createErrorReducer(ERROR);
const warningsById = createErrorReducer(WARNING);
const infoById = createErrorReducer(INFO);
const successesById = createErrorReducer(SUCCESS); // TODO: Refactor to store under sessionId?
// What about when a widget with a sessionId is deleted within a layout?
// We would need middleare to clean that up.

/*
 * {
 *   codeHublErrorsById: {
 *     12345: {
 *       [sessionId]: [],
 *       [sessionId]: [],
 *     }
 *   }
 * }
 */

const createCodeErrorReducer = ({
  SET,
  CLEAR,
  CLEAR_ALL
}) => {
  return (state = EMPTY_OBJECT, action) => {
    const {
      assetId
    } = action;

    switch (action.type) {
      case SET:
        return setErrors(state, assetId, action.errors);

      case CLEAR:
        return state[assetId] ? SeamlessImmutable.without(state, assetId) : state;

      case CLEAR_ALL:
      case EDITOR_ERRORS_CLEAR_ALL:
        return EMPTY_OBJECT;

      default:
        return state;
    }
  };
};

const codeHublErrorsById = createCodeErrorReducer({
  SET: EDITOR_ERRORS_HUBL_SET,
  CLEAR: EDITOR_ERRORS_HUBL_CLEAR,
  CLEAR_ALL: EDITOR_ERRORS_HUBL_CLEAR_ALL
});
const codeCssErrorsById = createCodeErrorReducer({
  SET: EDITOR_ERRORS_CSS_SET,
  CLEAR: EDITOR_ERRORS_CSS_CLEAR,
  CLEAR_ALL: EDITOR_ERRORS_CSS_CLEAR_ALL
});
const codeJsErrorsById = createCodeErrorReducer({
  SET: EDITOR_ERRORS_JS_SET,
  CLEAR: EDITOR_ERRORS_JS_CLEAR,
  CLEAR_ALL: EDITOR_ERRORS_JS_CLEAR_ALL
});
export default combineReducers({
  errorsById,
  warningsById,
  infoById,
  successesById,
  codeHublErrorsById,
  codeCssErrorsById,
  codeJsErrorsById
});